module.exports = __webpack_public_path__ + "static/img/welcome.ce7ae0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welcome.png
// module id = 6ozE
// module chunks = 1